import React from "react";
import {
  Box,
  Button,
  IconButton,
  TableCell,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { Close, DeleteOutline, Edit, Save } from "@mui/icons-material";
import TableDesign, {
  TableHeading,
} from "../../../../components/common/table/TableDesign";

interface TaskTableSectionProps {
  data: any[];
  editingRowId: number | null;
  filterOption: any;
  setFilterOption: any;
  onAddNew: () => void;
  onEdit: (id: number) => void;
  onSave: (row: any) => void;
  onCancel: () => void;
  onChange: (id: number, field: string, value: string) => void;
  onDelete: (id: number) => void;
}

const tableHeadings: TableHeading[] = [
  { label: "Task Type (Editable)", align: "left" },
  { label: "Detail (Editable)", align: "left" },
  { label: "Appears in", align: "left" },
  { label: "Actions", align: "center" },
];

const textFieldSx = {
  width: 250,
  "& .MuiInputBase-root": {
    height: 28,
  },
  "& .MuiInputBase-input": {
    padding: "2px 8px",
    fontSize: "13px",
  },
  "& .MuiInputLabel-root": {
    fontSize: "13px",
  },
};

const TaskTableSection = ({
  data,
  editingRowId,
  filterOption,
  setFilterOption,
  onAddNew,
  onEdit,
  onSave,
  onCancel,
  onChange,
  onDelete,
}: TaskTableSectionProps) => {
  return (
    <Box
      sx={{
        bgcolor: "#fff",
        border: "1px solid #d1cfcf",
        borderRadius: "5px",
        overflow: "hidden",
        mt: 4,
      }}
    >
      <Box sx={{ p: 1 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography sx={{ fontSize: "18px", fontWeight: 600 }}>
            Tasks
          </Typography>
          <Button variant="contained" size="small" onClick={onAddNew}>
            Add New
          </Button>
        </Box>
      </Box>

      <TableDesign
        tableHeadings={tableHeadings}
        tableHeadColor="#02906f"
        cellColor="#fff"
        pagination={null}
        isLoader={false}
        stickyHeader={true}
        filterOption={filterOption}
        setFilterOption={setFilterOption}
        extraCSS={{ height: "100%" }}
      >
        {data.map((row: any, i: number) => (
          <TableRow key={i} sx={{ height: 36 }}>
            <TableCell>
              {editingRowId === row.id ? (
                <TextField
                  size="small"
                  value={row.name}
                  onChange={(e) => onChange(row.id, "name", e.target.value)}
                  sx={textFieldSx}
                />
              ) : (
                row.name
              )}
            </TableCell>

            <TableCell>
              {editingRowId === row.id ? (
                <TextField
                  size="small"
                  fullWidth
                  value={row.description}
                  onChange={(e) =>
                    onChange(row.id, "description", e.target.value)
                  }
                  sx={textFieldSx}
                />
              ) : (
                row.description
              )}
            </TableCell>

            <TableCell>
              {editingRowId === row.id ? (
                <TextField
                  size="small"
                  value={row.id < 0 ? "Work Diary" : row.appears_in}
                  disabled={true}
                  onChange={(e) =>
                    onChange(row.id, "appears_in", e.target.value)
                  }
                  sx={textFieldSx}
                />
              ) : (
                row.appears_in
              )}
            </TableCell>

            <TableCell align="center">
              {!row?.id  ? (
                <>
                  <IconButton color="success" onClick={() => onSave(row)}>
                    <Save fontSize="small" />
                  </IconButton>
                  <IconButton color="error" onClick={() => onDelete(row.id)}>
                    <DeleteOutline fontSize="small" />
                  </IconButton>
                </>
              ) : (
                <>
                  {row?.is_editable && (
                    <>
                      {editingRowId === row.id ? (
                        <>
                          <IconButton color="success" onClick={() => onSave(row)}>
                            <Save fontSize="small" />
                          </IconButton>
                          <IconButton color="default" onClick={onCancel}>
                            <Close fontSize="small" />
                          </IconButton>
                        </>
                      ) : (
                        <IconButton color="primary" onClick={() => onEdit(row.id)}>
                          <Edit fontSize="small" />
                        </IconButton>
                      )}
                    </>
                  )}
                  {row?.is_deletable && (
                    <IconButton color="error" onClick={() => onDelete(row.id)}>
                      <DeleteOutline fontSize="small" />
                    </IconButton>
                  )}
                </>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableDesign>
    </Box>
  );
};

export default TaskTableSection;
